import { Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import { IAsset } from './asset.interface';

@Component({
    selector: 'clearance-document',
    standalone: false,
    templateUrl: 'clearance-item-document.component.html',
    styles: [`
        :host {
          display: block;
          flex: 0 0 auto;
          width: 88px;
          max-width: 33.333%;
          box-sizing: border-box;
          margin: 0 12px 12px 0;
        }
        :host > div {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        @media (max-width: 600px) {
          :host {
            max-width: 50%;
          }
        }
    `]
})

export class ClearanceItemDocumentComponent extends  ClearanceItemAssetBaseComponent implements IAsset {

    setDefaultAssetImage() {
        throw new Error("Method not implemented.");
    }
}